
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tsunagu/link_redirect",
      function () {
        return require("private-next-pages/tsunagu/link_redirect/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tsunagu/link_redirect"])
      });
    }
  